namespace Matrix.Data {
    export interface ClientFieldRow {
        TableSchema?: string;
        Tablename?: string;
        FieldName?: string;
        Expression?: string;
        PropertyName?: string;
        DisplayName?: string;
        DataType?: string;
        DataPrecision?: number;
        DataScale?: number;
        SqlDefault?: string;
        PrimaryKey?: boolean;
        Identity?: boolean;
        IsNotNull?: boolean;
        Insertable?: boolean;
        Updatable?: boolean;
        EditLink?: boolean;
        ForeignTable?: string;
        ForeignField?: string;
        JoinAlias?: string;
        IsRequired?: boolean;
        VisibleInForm?: boolean;
        FormTab?: string;
        FormCategory?: string;
        FormWidth?: string;
        FormWidthUntilNext?: boolean;
        FormWidthJustThis?: boolean;
        LabelWidth?: string;
        LabelWidthUntilNext?: boolean;
        LabelWidthJustThis?: boolean;
        DefaultValue?: string;
        MaxLength?: number;
        DecimalPlaces?: number;
        DateTimeKind?: System.DateTimeKind;
        EditorType?: string;
        EditorParams?: string;
        VisibleInGrid?: boolean;
        Width?: number;
        Alignment?: string;
        FormatterType?: string;
        FormatterParams?: string;
        DisplayFormat?: string;
        FilterOnly?: boolean;
        Cloneable?: boolean;
        QuickSearchType?: Serenity.Data.Mapping.SearchType;
        LookupInclude?: boolean;
        DisplayOrder?: number;
        SortOrder?: number;
        GroupOrder?: number;
        SummaryType?: number;
        ReadPermission?: string;
        ModifyPermission?: string;
        Properties?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ClientFieldRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'FieldName';
        export const localTextPrefix = 'Data.ClientField';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TableSchema = "TableSchema",
            Tablename = "Tablename",
            FieldName = "FieldName",
            Expression = "Expression",
            PropertyName = "PropertyName",
            DisplayName = "DisplayName",
            DataType = "DataType",
            DataPrecision = "DataPrecision",
            DataScale = "DataScale",
            SqlDefault = "SqlDefault",
            PrimaryKey = "PrimaryKey",
            Identity = "Identity",
            IsNotNull = "IsNotNull",
            Insertable = "Insertable",
            Updatable = "Updatable",
            EditLink = "EditLink",
            ForeignTable = "ForeignTable",
            ForeignField = "ForeignField",
            JoinAlias = "JoinAlias",
            IsRequired = "IsRequired",
            VisibleInForm = "VisibleInForm",
            FormTab = "FormTab",
            FormCategory = "FormCategory",
            FormWidth = "FormWidth",
            FormWidthUntilNext = "FormWidthUntilNext",
            FormWidthJustThis = "FormWidthJustThis",
            LabelWidth = "LabelWidth",
            LabelWidthUntilNext = "LabelWidthUntilNext",
            LabelWidthJustThis = "LabelWidthJustThis",
            DefaultValue = "DefaultValue",
            MaxLength = "MaxLength",
            DecimalPlaces = "DecimalPlaces",
            DateTimeKind = "DateTimeKind",
            EditorType = "EditorType",
            EditorParams = "EditorParams",
            VisibleInGrid = "VisibleInGrid",
            Width = "Width",
            Alignment = "Alignment",
            FormatterType = "FormatterType",
            FormatterParams = "FormatterParams",
            DisplayFormat = "DisplayFormat",
            FilterOnly = "FilterOnly",
            Cloneable = "Cloneable",
            QuickSearchType = "QuickSearchType",
            LookupInclude = "LookupInclude",
            DisplayOrder = "DisplayOrder",
            SortOrder = "SortOrder",
            GroupOrder = "GroupOrder",
            SummaryType = "SummaryType",
            ReadPermission = "ReadPermission",
            ModifyPermission = "ModifyPermission",
            Properties = "Properties",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
